import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: "root",
})
export class LocaleService {
    constructor(private readonly translateService: TranslateService) {}

    getLocale(): string {
        const curLang = this.translateService.currentLang;

        const curLocale =
            curLang === "nl"
                ? "nl-BE"
                : curLang === "de"
                  ? "de-DE"
                  : curLang === "sv"
                    ? "sv-SE"
                    : curLang === "no"
                      ? "no-NO"
                      : "en-GB";

        return curLocale;
    }
}
